import { Button, ButtonGroup, NativeButtonProps, MarginSprinkles } from '@ff-it/ui';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

export interface Action {
  action: string;
  button?: Partial<NativeButtonProps> & { to?: string; target?: string };
}

export type ActionsProps = {
  disabled?: boolean;
  actions: Action[];
  size?: NativeButtonProps['size'];
} & MarginSprinkles;

export function Actions({ actions, disabled, size, ...rest }: ActionsProps): ReactElement {
  const buttons = actions.map(
    ({ button: { children, className: btnClassName, to, target, ...button } = {}, action }) => {
      return (
        <Button
          type="button"
          key={action}
          testId={`action-${action}`}
          className={btnClassName}
          disabled={disabled}
          size={size}
          {...button}
          asChild={!!to}
        >
          {to ? (
            <Link to={to} target={target}>
              {children}
            </Link>
          ) : (
            children
          )}
        </Button>
      );
    },
  );
  return <ButtonGroup {...rest}>{buttons}</ButtonGroup>;
}
